import { useState } from "react";
import { ArrowRight, Plus, Send, Sparkles } from "lucide-react";
import { ConnectionLogo } from "./ConnectionLogo";
import { routeWord } from "./connectionsModel";

// The Add section at the top of the page, on the hero's navy: tell the agent what to connect (which opens the
// chat bubble with that sentence as the first message), the apps brands reach for most, See all, Something else.

export function AppTile({ choice, disabled = false, onChoose, size = 34 }) {
  return (
    <button type="button" className="cx-hero__app" data-testid={`connections-add-shelf-${choice.app}`} disabled={disabled} onClick={() => onChoose(choice)}>
      <ConnectionLogo app={choice.app} label={choice.label} size={size} />
      <span className="cx-hero__app-name">{choice.label}</span>
      <span className="cx-hero__app-route">{routeWord(choice.flow)}</span>
    </button>
  );
}

export default function AddConnections({ choices = [], total = 0, agentName = "your agent", busyKey = null, chatAvailable = false, onChoose, onAsk, onSeeAll, onCustom }) {
  const [text, setText] = useState("");
  const ask = (event) => {
    event?.preventDefault?.();
    const message = text.trim();
    if (!message || !onAsk) return;
    setText("");
    onAsk(message);
  };
  return (
    <section className="cx-hero" data-testid="connections-add-shelf" aria-labelledby="connections-add-shelf-title">
      <div className="cx-hero__head">
        <div className="cx-hero__copy">
          <h2 id="connections-add-shelf-title" className="cx-hero__title">Add a connection</h2>
          <p className="cx-hero__sub">{chatAvailable ? `Tell ${agentName} what to connect. It signs in where it can, links where it must, and asks for a key only when nothing else works.` : `Pick an app. ${agentName[0].toUpperCase() + agentName.slice(1)} can use it the moment it is connected.`}</p>
        </div>
        <button type="button" className="cx-btn cx-btn--onnavy" data-testid="connections-add-shelf-all" onClick={onSeeAll}>{total > choices.length ? `See all ${total} apps` : "See all apps"}<ArrowRight size={14} /></button>
      </div>
      {chatAvailable && onAsk ? (
        <form className="cx-hero__ask" onSubmit={ask}>
          <span className="cx-hero__spark" aria-hidden="true"><Sparkles size={15} /></span>
          <input type="text" value={text} onChange={(event) => setText(event.target.value)} placeholder={`Ask ${agentName} to connect something…`} aria-label={`Ask ${agentName} to connect something`} data-testid="connections-ask-input" autoComplete="off" />
          <button type="submit" className="cx-btn cx-btn--primary" data-testid="connections-add-shelf-agent" disabled={!text.trim()}><Send size={14} />Ask {agentName}</button>
        </form>
      ) : null}
      {choices.length || onCustom ? (
        <div className="cx-hero__apps">
          {choices.map((choice) => <AppTile key={choice.app} choice={choice} disabled={busyKey === `add:${choice.app}` || busyKey === choice.app} onChoose={onChoose} />)}
          {onCustom ? <button type="button" className="cx-hero__app cx-hero__app--more" data-testid="connections-add-shelf-custom" onClick={onCustom}><span className="cx-hero__plus" aria-hidden="true"><Plus size={16} /></span><span className="cx-hero__app-name">Something else</span><span className="cx-hero__app-route">With a key</span></button> : null}
        </div>
      ) : null}
    </section>
  );
}
